import type { PortMode } from './layoutTypes';

export interface FlowInterface {
  psd: number[];
  size: number[];
  moisture: number;
  workIndex: number;
  bulkDensity: number;
  abrasionIndex: number;
  specificGravity: number;
  totalMass: number;
  clay: number;
  materialId?: string;
  materialName: string;
  wetScreen: boolean;
  psdName: string;
  psdId?: string;
  otherPsdName?: string | undefined;
  maxStoneSize?: number;
  otherMaterialName?: string | undefined;
}

export interface NotesInterface {
  noteOne: string | undefined;
  noteTwo: string | undefined;
  noteThree: string | undefined;
  noteFour: string | undefined;
  noteFive: string | undefined;
}

export interface DisplayNotesInterface {
  noteOne: boolean;
  noteTwo: boolean;
  noteThree: boolean;
  noteFour: boolean;
  noteFive: boolean;
}

export interface FlowPropertiesInterface {
  outputs: OutputFlowMapInterface;
  display: {
    displayPxxGradation: boolean;
    displayPxxValue1: boolean;
    displayPxxValue2: boolean;
    displayPxxValue3: boolean;
    displayGraph: boolean;
    displaySizeGradation: boolean;
    displaySize: boolean;
    displayNormalMassFlow: boolean;
    displayBulkDensity: boolean;
    displayWorkIndex: boolean;
    displayAbrasionIndex: boolean;
    displayClay: boolean;
    displayMoisture: boolean;
  };
  sizeMode: string;
  graphMode: string;
  pxxMode: string;
  psdCalcMode: string;
  pxxOne?: number | undefined;
  pxxTwo?: number | undefined;
  pxxThree?: number | undefined;
  fractionOne?: number | undefined;
  fractionTwo?: number | undefined;
  size: number[];
  psdName: string;
  otherPsdName?: string | undefined;
  activePortIndex: number;
}

export interface OutputFlowMapInterface {
  [outputKey: string]: OutputFlowInterface;
}

export interface OutputFlowInterface {
  pxxValues: { x: number; y: number }[] | undefined;
}

export interface PortInterface {
  key: string;
  unitKey: string;
  portMode: PortMode;
  portIndex: number;
  outputFlow?: PortOutputFlowInterface;
}

export interface PortInterfaceWithName extends PortInterface {
  name: string;
}

export enum DisplayGraphMode {
  DISCHARGE_ONLY = 'Discharge',
  FEED_AND_DISCHARGE = 'Feed and discharge',
}

export interface PortOutputFlowInterface {
  psd: number[];
  size: number[];
  lowerFractionSize: number;
  moisture: number;
  totalMass: number;
  upperFractionSize: number;
  clay: number;
  workIndex: number;
  bulkDensity: number;
  abrasionIndex: number;
  topSize: number;
  specificGravity: number;
}

export interface PortsMapInterface {
  [key: string]: PortInterface[];
}
